import { ChainId } from '@heshiswap/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x8d28dBE26a933A16E28BAD7cf92ace8f8F0d2f0D',
  [ChainId.TESTNET]: '0x987493B651F91D01F5Bc8f59E9f701765E31C5b4'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
